import { LLMProfileEffort } from '@/lib/api/generated/model';
import type { LLMProfileEffort as LLMProfileEffortType } from '@/lib/api/generated/model';

/**
 * Human-readable labels for the closed effort enum, shared between the list and
 * the form — Base UI's `SelectValue` renders the raw value unless given a label
 * function (see `StepInspector.tsx`'s identical note for step type/gate mode).
 */
export const EFFORT_LABELS: Record<LLMProfileEffortType, string> = {
  [LLMProfileEffort.low]: 'Low',
  [LLMProfileEffort.medium]: 'Medium',
  [LLMProfileEffort.high]: 'High',
  [LLMProfileEffort.xhigh]: 'Extra high',
  [LLMProfileEffort.max]: 'Max',
};

export const EFFORT_OPTIONS: LLMProfileEffortType[] = [
  LLMProfileEffort.low,
  LLMProfileEffort.medium,
  LLMProfileEffort.high,
  LLMProfileEffort.xhigh,
  LLMProfileEffort.max,
];
